<script>
export default {
  name: "DidoApidocUsageColumns",
};
</script>

<template>
  <div class="q-mt-md line-height-15">
    La pagination ou l'export des données d'un millésime, d'un référentiel ou
    d'une nomenclature peuvent être paramétrés pour n'utiliser qu'un nombre
    réduit de colonnes.
    <br /><br />
    Il faut utiliser le paramètre
    <span class="bg-black text-white q-pa-xs">columns</span> dans la requête.
    <br /><br />
    Le paramètre
    <span class="bg-black text-white q-pa-xs">columns</span> doit être construit
    de la manière suivante :
    <span class="bg-black text-white q-pa-xs">columns=colonne1,colonne2</span>.
    <br /><br />
    Par défaut si le paramètre
    <span class="bg-black text-white q-pa-xs">columns</span> n'existe pas dans
    la requête, toutes les colonnes sont renvoyées.
  </div>
</template>
